<template>
  <div>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card outlined flat tile color="#F2F2F2">
          <v-layout justify-center wrap py-12>
            <v-flex xs8>
              <span class="customerHead">Blog</span>
            </v-flex>
          </v-layout>
          <v-layout justify-center wrap v-if="items.length > 0" pb-16>
            <v-flex xs12>
              <OwlCarousel
                :nav="true"
                :dots="false"
                :responsive="owlResponsive"
              >
                <v-flex
                  py-2
                  v-for="(item, i) in items"
                  :key="i"
                  px-lg-2
                  xs12
                  sm11
                  md11
                  lg11
                >
                  <v-img :src="item.image"></v-img>
                  <span class="blogTitle">{{ item.title }}</span>
                  <v-layout justify-start wrap>
                    <v-flex xs3>
                      <span class="blogName">{{ item.name }}</span>
                    </v-flex>
                    <v-flex xs9>
                      <span class="blogName">{{ item.time }}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </OwlCarousel>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          image: require("./../../assets/images/Rectangle 256.png"),
          title:
            "Our focus is on Data Science and possibilities of Machine Learning and Block Chain",
          name: "Dmaac.com",
          time: "5 min ago",
        },
        {
          image: require("./../../assets/images/Rectangle 257.png"),
          title:
            "Our focus is on Data Science and possibilities of Machine Learning and Block Chain",
          name: "Dmaac.com",
          time: "5 min ago",
        },
        {
          image: require("./../../assets/images/Rectangle.png"),
          title:
            "Our focus is on Data Science and possibilities of Machine Learning and Block Chain",
          name: "Dmaac.com",
          time: "5 min ago",
        },
        {
          image: require("./../../assets/images/Rectangle 259.png"),
          title:
            "Our focus is on Data Science and possibilities of Machine Learning and Block Chain",
          name: "Dmaac.com",
          time: "5 min ago",
        },
      ],
      owlResponsive: {
        0: { items: 1, nav: false },
        600: { items: 3, nav: false },
        960: { items: 3, nav: false },
        1264: { items: 3, nav: false },
        1364: { items: 3, nav: false },
      },
    };
  },
};
</script>
<style>
.blogTitle {
  color: #000000;
  font-family: ibmplexsanssemibold;
}
.blogName {
  color: #707070;
  font-family: ibmplexsansregular;
  font-size: 12px;
}
</style>